import styled from 'styled-components';

const thBase = styled.th`
  text-align: left;
  padding: 14px 18px;
  vertical-align: middle;
  white-space: nowrap;
`;

const tdBase = styled.td`
  padding: 15px 18px;
  min-height: 52px;
  box-sizing: border-box;
  vertical-align: middle;
  border: none;
  border-bottom: 1px solid #ececec;
  background: #fff;
  font-size: 0.8125rem;
  font-weight: 400;
  color: #3d4f63;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ChatsWhatsappRow = styled.tr`
  cursor: pointer;
  background-color: #fff;
  transition: background-color 0.15s ease;

  &:hover td {
    background-color: ${(props) => props.theme['table_line-hover']} !important;
  }
`;

export const ChatsWhatsappThContato = styled(thBase)``;

export const ChatsWhatsappThTelefone = styled(thBase)``;

export const ChatsWhatsappThCorretor = styled(thBase)``;

export const ChatsWhatsappThSolicitacao = styled(thBase)``;

export const ChatsWhatsappThUltimaMsg = styled(thBase)``;

export const ChatsWhatsappThMsgs = styled(thBase)`
  width: 80px;
  min-width: 80px;
  padding-left: 10px;
  padding-right: 10px;
  text-align: center;
`;

export const ChatsWhatsappThAtualizado = styled(thBase)``;

export const ChatsWhatsappThStatus = styled(thBase)`
  text-align: center;
`;

export const ChatsWhatsappTdContato = styled(tdBase)`
  font-weight: 600;
  color: #152b4e;
  max-width: 0;
`;

export const ChatsWhatsappTdTelefone = styled(tdBase)`
  font-variant-numeric: tabular-nums;
  max-width: 0;
`;

export const ChatsWhatsappTdCorretor = styled(tdBase)`
  max-width: 0;
  text-transform: none;
`;

export const ChatsWhatsappTdSolicitacao = styled(tdBase)`
  font-variant-numeric: tabular-nums;
  max-width: 0;
`;

export const ChatsWhatsappTdUltimaMsg = styled(tdBase)`
  max-width: 0;
  text-transform: none;
  color: #5c6a7a;
`;

export const ChatsWhatsappTdMsgs = styled(tdBase)`
  width: 80px;
  min-width: 80px;
  max-width: 80px;
  padding-left: 10px;
  padding-right: 10px;
  text-align: center;
  font-variant-numeric: tabular-nums;
  overflow: visible;
  text-overflow: clip;
`;

export const ChatsWhatsappTdAtualizado = styled(tdBase)`
  width: 148px;
  min-width: 148px;
  max-width: 148px;
  font-size: 0.78rem;
  color: #5c6a7a;
  font-variant-numeric: tabular-nums;
`;

export const ChatsWhatsappTdUltimaMsgData = styled(tdBase)`
  width: 160px;
  min-width: 160px;
  max-width: 160px;
  font-size: 0.78rem;
  color: #5c6a7a;
  font-variant-numeric: tabular-nums;
  overflow: visible;
  text-overflow: clip;
`;

export const ChatsWhatsappTdStatus = styled(tdBase)`
  width: 132px;
  min-width: 132px;
  max-width: 132px;
  text-align: center;
  text-transform: none;
  overflow: visible;
`;

export const ChatsWhatsappCellEllipsis = styled.span`
  display: block;
  width: 100%;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ChatsWhatsappTableScroll = styled.div`
  position: relative;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  min-height: ${(props) => (props.loading ? '200px' : 'auto')};

  table {
    width: 100%;
    min-width: ${(props) => (props.$chatTipo === 'solicita' ? '1080px' : '1200px')} !important;
    border-collapse: collapse;
    table-layout: fixed;
  }

  tbody tr:last-child td {
    border-bottom: none;
  }
`;

export const ChatsWhatsappTableEl = styled.table`
  margin: 0;
`;
